import { api } from '../../../api';
import { ApiResponse } from '../../Utilities';
import { ERPGatewayConfigurationViewModel } from '../../ViewModels';

export class ERPGatewayConfigurationApi {
    private route = '/ERPGatewayConfiguration';

    public getERPGatewayConfiguration = (id: number): ApiResponse<ERPGatewayConfigurationViewModel> => {
        return api().get(`${this.route}/${id}`);
    };

    public getERPGatewayConfigurationByCompanyId = (
        companyId: number
    ): ApiResponse<ERPGatewayConfigurationViewModel[]> => {
        return api().get(`${this.route}?companyId=${companyId}`);
    };

    public putERPGatewayConfiguration = (id: number, data: ERPGatewayConfigurationViewModel): ApiResponse<void> => {
        return api().put(`${this.route}/${id}`, data);
    };
}
